import Swiper from "swiper";
import { Navigation, Pagination, Thumbs, Autoplay, Scrollbar, Controller, EffectFade, Manipulation } from "swiper/modules";

const productGallery = () =>({
	galleryThumbnail: null,
	galleryMain: null,
	variantSelectors:[],
	sliderInitialized: false,
	thumbnailSliderInitialized: false,
	init() {
		this.imageGallery();
		this.variantSelectors = document.querySelectorAll('.variant-slider-js')
		this.scrollToSelectedVariantImage()

		this.variantSelectors.forEach(variantSelector => {
			variantSelector.addEventListener("click", ()=>{
				this.scrollToSelectedVariantImage()
			})
		});
	},
	imageGallery() {
		this.$nextTick(()=>{
			let gallery_thumbnail_swiper = this.$el.querySelector('.product-thumbnails-slider');
			let gallery_main_swiper = this.$el.querySelector('.product-gallery-slider');
			if (gallery_thumbnail_swiper) {
				this.galleryThumbnail = new Swiper(gallery_thumbnail_swiper, {
					modules: [Navigation, Controller, Manipulation, Thumbs],
					...{
						slidesPerView: 8,
						freeMode: true,
						watchSlidesProgress: true,
						autoWidth: true,
						breakpoints: {
							0: {
								spaceBetween: 4
							},
							1024: {
								spaceBetween: 10
							}
						}
					}
				});
			}

			this.galleryMain = new Swiper(gallery_main_swiper, {
				modules: [Navigation, Pagination, Scrollbar, Controller, Thumbs],
				...{
					grabCursor: true,
					spaceBetween: 1,
					navigation: {
						nextEl: '[data-main-slider-arrow-next]',
						prevEl: '[data-main-slider-arrow-prev]',
					},
					thumbs:{
						swiper: this.galleryThumbnail && this.galleryThumbnail
					},
					breakpoints: {
						0:{
							slidesPerView: 1
						},
						990: {
							slidesPerView: 1,
							spaceBetween: 1
						},
					}
				}

			});
			this.sliderInitialized = true
			this.thumbnailSliderInitialized = true
		})
	},
	slideToIndex(index) {
		this.galleryMain.slideToLoop(index, 10)
	},
	scrollToSelectedVariantImage(){
		setTimeout(()=>{
			if (document.getElementById("js-image-id")){
				let ImageID = document.getElementById("js-image-id").value;
				let galleryImage = '.media-' + ImageID

				if (document.querySelector(galleryImage)){
					let slideIndex = document.querySelector(galleryImage).getAttribute('data-slide-index');
					this.galleryMain.slideTo(parseInt(slideIndex))
				}
			}
		}, 0)
	},
    reinitImageGallery() {
		this.$nextTick(()=>{
        if (this.galleryMain) {
          this.galleryMain.destroy(true, true);
        }
        if (this.galleryThumbnail) {
          this.galleryThumbnail.destroy(true, true);
        }
     
             this.imageGallery()
         })
    }
})

export default productGallery

window.addEventListener("alpine:init", () => {
	Alpine.data("productGallery", productGallery);
})
